<div class="why-branfort-outer">
  <div class="banner-with-text cmsBannerOverlay" [ngStyle]="{ 'background-image': 'url(' + backgroundPic + ')' }"
    *ngIf="routeData.showHeader">
    <div class="container">
      <div class="row">
        <div class="col-12" *ngIf="routeData.title">
          <h1 class="hdg">{{ routeData.title | titlecase }}</h1>
          <h5 class="sb-hdg">{{ routeData.subtitle }}</h5>
        </div>
      </div>
    </div>
  </div>
  <div class="public-wrap">
    <div class="container">
      <ng-container *ngIf="currentStaticPage === staticPage.FAQ; else withWhitebg">
        <div class="faq_page_wrapper">
          <div class="row mb-3 pb-2">
            <div class="col-12">
              <h1>Frequently Asked Questions</h1>
            </div>
          </div>
          
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Account & Registration</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do your auctions work?">
                      <div class="content-wrapper">
                        <p>Auctions can take place on one of several bidding platforms, or
                          in several different formats.  Sale specific information will be 
                          available on the Auction Details page for the auction.
                          Follow the Registration link on the sale you are interested in 
                          to Register and Bid. 
                        </p>
                        <p>
                          At the conclusion of the auction, you will receive an invoice.
                          Once your invoice is paid you or your agent can remove the items 
                          in coordination with the removal agent listed on your invoice.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I create an account?">
                      <div class="content-wrapper">
                        <p>
                          Account Details can be managed on the website you are bidding on.
                          
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What if I forget my password or username?">
                      <div class="content-wrapper">
                        <p>
                          The platform you are bidding on will have a mechanism to reset your password.
                          Contact our office at 203-488-7020 for assistance with BranfordAuctions.com sales.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Bidding</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I bid in an online auction?">
                      <div class="content-wrapper">
                        <p>
                          The first step of the process is to create an account
                          on the bidding platform by filling out some basic information
                          about yourself. Next, you can Register for the auction
                          you are interested in. You may sign up for as many
                          auctions as you're interested in. Customer Service
                          will review your registration, and may request a
                          deposit before approval. Once you're approved, you are
                          free to bid!
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I bid in a studio webcast auction?">
                      <div class="content-wrapper">
                        <p>
                          A studio webcast auction is a live auction event
                          broadcasted via the web. Bidders can participate by
                          bidding in-person at the auction location, or register
                          to bid online on the designated online platform where
                          bids are called in real time. You will be able to hear
                          the auctioneer calling bids and view images and
                          descriptions of each lot being auctioned off.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I place a max bid? ">
                      <div class="content-wrapper">
                        <p>
                          Placing a Max Bid is as simple as tying the highest
                          amount you are willing to bid into the bidding fields
                          and clicking Submit Bid.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Removal</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I get my items shipped to me?">
                      <div class="content-wrapper">
                        <p>
                          The Branford Group does not pack, ship, store, crate
                          or rig items. Buyers or their company representative
                          may either pick up their items at the designated
                          auction site personally, or can arrange for a
                          third-party logistics firm to manage the removal
                          process for them. You, or your third-party logistics
                          company must present your paid invoice at time of
                          removal. Each auction will have a removal contact
                          listed on your invoice. You can call, text or email to
                          make an appointment with them for removal (or show up
                          during designated hours if an appointment is not
                          necessary)
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I get listed to be a rigger on an auction?">
                      <div class="content-wrapper">
                        <p>
                          Visit our
                          <a routerLink="/removal" class="clickLink" target="_blank"
                            rel="noopener noreferrer">Removal/Rigging</a>
                          page for more information.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What do I need to supply to remove my items?">
                      <div class="content-wrapper">
                        <p>
                          You must show a copy of your PAID invoice to the
                          onsite contact. If a third-party rigging company is
                          removing your item(s) you must provide them with a
                          copy of your paid invoice as proof of purchase or
                          complete an
                          <a class="clickLink" [href]="removalDocuments[0].name" target="_blank">Agent Release form</a>
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Invoices & Payment</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="When will I receive my invoice?">
                      <div class="content-wrapper">
                        <p>
                          Invoices are usually sent out within a few hours of
                          the auction closing, but in some cases may take up to
                          24 hours. Please check your junk mail folder if you
                          are still having trouble receiving it.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I pay my invoice?">
                      <div class="content-wrapper">
                        <p>
                          Detailed payment information will be available on your invoice.  This may include a link to a payment form as well as any sale-specific instructions.
                        </p>
                        <p>
                          Visit our
                          <a routerLink="/payments" class="clickLink" target="_blank" rel="noopener noreferrer">Payments
                            & Invoices</a>
                          page for an overview of what to expect.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I get the taxes removed from my invoice?">
                      <div class="content-wrapper">
                        <p>
                          If you are sales tax exempt, you can fill out the
                          correct
                          <a routerLink="/payments" class="clickLink" target="_blank"
                            rel="noopener noreferrer">Tax-Exempt Form</a>
                          and Email your completed form to
                          <a href="mailto:service@thebranfordgroup.com"
                            class="clickLink">service@thebranfordgroup.com</a>
                          to have a revised invoice sent to you. Each state is
                          different - please refer to the email that your
                          invoice was attached to. If you are exporting and
                          planning to submit a Bill of Lading, please let us
                          know ahead of time. Provided the state allows it, we
                          will refund the sales tax after receiving the Bill of
                          Lading.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Auction Definitions</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What is a Timed Online Auction?">
                      <div class="content-wrapper">
                        <p>
                          A Timed Online Auction will take place online. You
                          will have access to a Lot Catalog, a listing of items
                          available for auction. You will have a window of at
                          least 24 hours to enter in your bids.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group
                      heading="In a Timed Online Auction, what happens when people bid at the last second?">
                      <div class="content-wrapper">
                        <p>
                          Items that have bids placed within the last few minutes will generally be extended
                          for some time.  Depending on the auction platform this may be up to 5-10 minutes.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What is a Webcast and/or Onsite Auction?">
                      <div class="content-wrapper">
                        <p>
                          A Webcast and/or On-Location Auction is a more traditional
                          auction, where an auctioneer will call bids one at a time
                          and bidders will place their bids in a fast-paced
                          competitive bidding environment. This may be done one
                          of three ways:
                        </p>
                        <ol style="list-style-type: disc;">
                          <li>Studio Webcast: An auctioneer will call the bids via internet livestream.</li>
                          <li>Onsite Auction: An auctioneer will call the bids in person, and bidders will be placing
                            bids with physical paddle numbers.</li>
                          <li>Webcast & On Location: A Hybrid auction, where bidding will take place at the auction
                            site, but bids will be accepted over the internet as well.</li>
                        </ol>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What is a Max Bid?">
                      <div class="content-wrapper">
                        <p>
                          The Max Bid system allows you to enter a bid higher
                          than the next required bid. The system will
                          automatically place the minimum required bid in order
                          to win the lot, up to the number you enter. This is a
                          useful feature if you are going to be away from your
                          computer or are monitoring many lots in a sale.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What is a Bulk Bid?">
                      <div class="content-wrapper">
                        <p>
                          A Bulk Bid is a competitive bidding process in a Timed
                          Online Auction where a single Lot will represent
                          several items for auction. Buyers can bid on either
                          the entire package, or the individual items. In some
                          cases, the Bulk Bidder or Piecemeal Bidders may be
                          given a percentage-based advantage in deciding which
                          bid to accept, this information will be displayed
                          within the Catalog during the bidding process. Only
                          one of the two methods of sale will be awarded the
                          items.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="What is a buyers premium?">
                      <div class="content-wrapper">
                        <p>
                          A Buyers Premium (BP) is a service charge
                          added to the winning bid/hammer price on all sales.
                          For most auctions we invoice at 21% BP for credit card
                          payments, then we discount the BP to 18% rate. The
                          lower rate invoice is available upon request for
                          payments by cash instrument (company/certified
                          check, wire transfer, or a direct deposit into our
                          Bank of America Account). You can pay adjusting the BP
                          yourself, or email letting us know how you will be
                          paying & requesting an updated invoice at the
                          discounted rate.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
          <section class="faq-section">
            <div class="row">
              <div class="col-12 mb-2">
                <h2>Contact</h2>
              </div>
              <div class="col-12">
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I contact The Branford Group?">
                      <div class="content-wrapper">
                        <p>
                          Our office phone number is
                          <a href="tel:+203-488-7020" class="clickLink">203-488-7020.</a>
                          Our Customer Service e-mail address is
                          <a href="mailto:service@thebranfordgroup.com"
                            class="clickLink">service@thebranfordgroup.com.</a>
                          Our office hours are Monday through Friday, 9:00 AM to
                          5:00 PM Eastern Time
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
                <div class="question-cards">
                  <accordion class="faq">
                    <accordion-group heading="How do I sign up to receive your auction email alerts?">
                      <div class="content-wrapper">
                        <p>
                          Simply enter your email address in our “Stay in the
                          Know” section at the bottom of our website and we will
                          keep you up to date on the latest auctions for the
                          category you select.
                        </p>
                      </div>
                    </accordion-group>
                  </accordion>
                </div>
              </div>
            </div>
          </section>
        </div>
      </ng-container>

      <ng-template #withWhitebg>
        <div class="public-wrap-inner">
          <ng-container [ngSwitch]="currentStaticPage">
            <ng-container *ngSwitchCase="staticPage.CLIENTS">
              <div class="whyClients">
                <h1 class="topHdg">Words From Our Clients</h1>
                <div class="whyClientsInner custon-slick-dots">
                  <ngx-slick-carousel class="carousel" [config]="whyChooseSlider">
                    <div ngxSlickItem class="slide">
                      <p>
                        The service provided was excellent. We received a quick
                        response to our inquiries and the job was completed in
                        the limited time frame in which we were working with.
                      </p>
                      <h3>T.A.P. Corporate Client</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        The service provided was excellent. We received a quick
                        response to our inquiries and the job was completed in
                        the limited time frame in which we were working with.
                      </p>
                      <h3>T.A.P. Corporate Client</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        The service provided was excellent. We received a quick
                        response to our inquiries and the job was completed in
                        the limited time frame in which we were working with.
                      </p>
                      <h3>T.A.P. Corporate Client</h3>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.REMOVAL">
              <div class="removal-wrap d-none">
                <p>
                  Over the last 15 years The Branford Group's management team
                  has worked with numerous riggers and transportation companies
                  around the world. As a team, we have developed strong
                  relationships with outside rigging and logistics providers. As
                  a result, The Branford Group's operation division works to
                  suggest and schedule independent service providers for
                  crating, packing, shipping and storing for each of our sales
                  events. Our goal is simple, to provide price competitive
                  rigging options combined with reliable service for our buyers.
                </p>

                <h3>For Buyers</h3>

                <div class="row mb-0 mb-md-3">
                  <div class="col-md-3">
                    <img alt="removal" class="removal-image img-fluid mb-2" src="/assets/images/removal1.jpg" />
                  </div>
                  <div class="col-md-9">
                    <p>
                      *The Branford Group does not pack, ship, store, crate or
                      rig items. Buyers may either pick up their items at the
                      designated auction site personally or can arrange for a
                      third party logistics firm to manage the removal process
                      for them. If someone other than the registered buyer at
                      the sale is designated to pick up those purchased assets,
                      the buyer must:
                    </p>
                  </div>
                </div>

                <ul class="pl-3">
                  <li>
                    Contract with an independent logistics firm or other
                    representative who will dismantle, crate, pack, or ship your
                    purchased items.
                  </li>
                  <li>
                    Coordinate the removal of those purchased items to meet the
                    time deadlines indicated on this page.
                  </li>
                  <li>
                    Submit an <a [href]="removalDocuments[0].name" target="_blank">"Agent Release Authorization"</a>
                    form
                    which will allow The Branford Group to release items to a
                    third party contractor for shipping, crating or packing
                    purposes.
                  </li>
                </ul>

                <p>
                  Since The Branford Group does not ship the items, we do not
                  obtain/prepare any export licenses/documents.
                </p>

                <p>
                  *The Branford Group finds and displays one or more local
                  logistics service providers who understand our removal
                  process, offer specific services, and have certain skills and
                  capacities. We offer this service to you without
                  representations or warranties of any kind whatsoever.
                </p>

                <div class="row mb-0 mb-md-3">
                  <div class="col-md-3">
                    <img alt="removal" class="removal-image img-fluid mb-2" src="/assets/images/removal2.jpg" />
                  </div>
                  <div class="col-md-9">
                    <p>
                      The Branford Group is not affiliated with any machinery
                      rigging, transport or export company. We provide the names
                      and contact information of available companies solely as a
                      courtesy to our buyers. The Branford Group does not
                      endorse or guarantee the services of any machinery
                      rigging, transport or export company, and cannot be held
                      responsible for any damage, omission or other problems
                      incurred as a result of the actions of those companies.
                      Buyers are encouraged to utilize a service provider of
                      their choice, provided they supply The Branford Group with
                      the required forms and insurance certificates.
                    </p>
                  </div>
                </div>

                <h3>For Riggers/Shippers:</h3>

                <p>
                  For most auctions, we list a select number of rigging and
                  shipping companies to assist our buyers. If you are interested
                  in being listed as a service provider in one of our upcoming
                  auctions, please fill out a
                  <a [href]="removalDocuments[1].name" target="_blank">Rigger Certificate Form.</a>
                </p>
              </div>
              <div class="sellerRecovery removal-wrap removal-wrap-new">
                <p class="desText pb-4">
                  Over the last 25 years The Branford Group's management team
                  has developed strong relationships with outside rigging and
                  logistics providers. As a result, we generally list rigging,
                  crating, packing, shipping and storing options for each of our
                  sales events. Our goal is to provide quality rigging options
                  combined with reliable service for our buyers.
                </p>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/equipment Removal.jpg" />
                    <h2 class="imageTextName">Equipment Removal</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText">
                    The Branford Group does not pack, ship, store, crate or rig
                    items. Buyers or their company representative may either
                    pick up their items at the designated auction site
                    personally, or can arrange for a third-party logistics firm
                    to manage the removal process for them. *Each auction will
                    have a removal contact listed on your invoice. You can call,
                    text or email to make an appointment with them for removal
                    (or show up during designated hours if an appointment is not
                    necessary)
                  </p>

                  <p class="desText">
                    If someone other than the registered buyer or company
                    representative is designated to pick up those purchased
                    assets, the buyer must:
                  </p>

                  <div class="pb-4">
                    <ul class="desText">
                      <li>
                        Contract with an independent logistics firm or other
                        representative who will dismantle, crate, pack, or ship
                        your purchased items.
                      </li>
                      <li>
                        Coordinate the removal of those purchased items to meet
                        the deadlines indicated on the auction webpage/invoice.
                      </li>
                      <li>
                        Submit an
                        <a [href]="removalDocuments[0].name" target="_blank" class="clickLink">Agent Release
                          Authorization Form</a>
                        which will allow The Branford Group to release items to
                        a third party contractor for shipping, crating or
                        packing purposes. Since The Branford Group does not ship
                        the items, we do not obtain/prepare any export
                        licenses/documents.
                      </li>
                    </ul>
                  </div>

                  <p class="desText pb-4">
                    The Branford Group is not affiliated with any machinery
                    rigging, transport or export company. We provide the names
                    and contact information of available companies solely as a
                    courtesy to our buyers. The Branford Group does not endorse
                    or guarantee the services of any machinery rigging,
                    transport or export company, and cannot be held responsible
                    for any damage, omission or other problems incurred as a
                    result of the actions of those companies. Buyers are
                    encouraged to utilize a service provider of their choice,
                    provided they supply The Branford Group with the required
                    forms and insurance certificates.
                  </p>
                </div>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/equipment_riggers.jpg" />
                    <h2 class="imageTextName">Equipment Riggers</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText">
                    Generally, we list a select number of rigging and shipping
                    companies to assist our buyers.
                  </p>
                  <p class="desText pb-4">
                    If you are interested in being listed as a service provider
                    in one of our upcoming auctions, please fill out a
                    <a [href]="removalDocuments[1].name" target="_blank" class="clickLink">Rigger Certificate Form</a>
                    and supply COI. You can scan and email the form to
                    <a href="mailto:service@thebranfordgroup.com" class="clickLink">service@thebranfordgroup.com</a>
                    or fax it to our office at 203-488-4577.
                  </p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.ASSET_RECOVERY">
              <div class="sellerRecovery">
                <p class="desText pb-4">
                  The Branford Group’s Asset Recovery Programs are customized to
                  cater to your specific needs. From start to finish - including
                  project assessment, cataloging, pricing, marketing,
                  inspection, auction, removal, and clean-up, our team is
                  involved every step of the way. We utilize several auction
                  methodologies in order to meet the needs of our sellers and
                  maximize convenience for buyers.
                </p>
                <!--BEGIN:: TIMED ONLINE AUCTION -->
                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/timed-online_auction.jpg" />
                    <h2 class="imageTextName">TIMED ONLINE AUCTION</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText pb-4">
                    To accommodate global bidding, auctions are “open” for
                    bidding for a minimum of 24 hours. Lots close sequentially
                    (usually minutes apart), and will auto-extend if last-minute
                    bidding occurs. The Branford Group uses its proprietary
                    bidding platform which includes an auto-bid feature -
                    allowing bidders the option to enter their maximum bid
                    price. This maximum bid feature is an excellent way for
                    bidders to not have to continuously monitor the sale. If a
                    bidder is outbid on a lot, our system provides automatic
                    notifications via email.
                  </p>
                </div>
                <!--END:: TIMED ONLINE AUCTION -->
                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/Webcast.png" />
                    <h2 class="imageTextName">Studio Webcast Auction</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText pb-4">
                    Typically paired with a live On-Site Auction, a Webcast
                    Auction is a theater-style sale held either on-location or
                    from a remote location. Registered bidders view a web-based
                    slideshow where we provide photographs and item descriptions
                    paired with a live audio feed. We simultaneously accepts
                    bids from on-site bidders as well as the bidders over the
                    web.
                  </p>
                </div>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/onsiteAuction.jpg" />
                    <h2 class="imageTextName">Live Onsite Auction</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText pb-4">
                    Conducted by one of our licensed auctioneers at (or near)
                    the site of the equipment to be sold. During the auction,
                    the auctioneers will sell each lot sequentially to the
                    highest bidder (pricing, increments, and grouping of lots
                    are determined in real time, and at the discretion of the
                    auctioneer.) Live onsite auctions are frequently accompanied
                    with a studio webcast feed to cater to an additional online
                    audience.
                  </p>
                </div>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/private_negotiated_sale.png" />
                    <h2 class="imageTextName">Private negotiated sale</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText pb-0">
                    A Private Negotiated Sale is managed by a Branford Group
                    executive who acts as the agent between the buyer and the
                    seller, allowing both parties to mutually agree upon a
                    price. We make all arrangements for preview and inspection
                    and provide a qualified list of logistics & rigging
                    companies to assist in timely removal of assets. This format
                    is often used for smaller groups of potential buyers who are
                    looking for unique, high-value items, entire lines, or a
                    complete business.
                  </p>
                </div>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/Treaty-Auction.jpg" />
                    <h2 class="imageTextName">Turnkey & real estate</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText">
                    In order to extract the highest possible returns for an
                    established business that still has a viable product line
                    and staffing, the turnkey/going concern sales option may be
                    the best option. These types of programs typically require a
                    longer marketing timeframe. Over the years our team has been
                    very successful in finding bulk buyers worldwide under this
                    model.
                  </p>
                  <div class="desktopAppraisalWrap desText">
                    <a [routerLink]="['/', routes.turnKeySale]" role="button" class="btn btn-colored">
                      View Past Turnkey Sales</a>
                  </div>
                </div>
                <div class="why-choose-map financial_structure">
                  <div class="histroyInnerBannerWrap cmsWrapperMar">
                    <div class="histroyInnerBannerWrap2">
                      <img src="/assets/images/financial_structure_banner.jpg" />
                      <h1>FINANCIAL STRUCTURES</h1>
                    </div>
                    <p class="desText py-3 mt-4 text-center subtext-content">
                      Our team believes strongly in working with our clients to
                      develop the optimal financial structure tailored to meet
                      their specific liquidation needs.
                    </p>
                    <div class="financstrslider custon-slick-dots">
                      <ngx-slick-carousel class="carousel" [config]="financstrslider">
                        <div ngxSlickItem class="slide" *ngFor="let data of dataAssets; let i as index">
                          <div class="content">
                            <h3>{{data?.title}}</h3>
                            <p>
                              {{(isReadMore) ? data?.description : getSplitData(data.description) }} <span
                                *ngIf="!isReadMore">...</span>
                              <a href="javascript:;" class="colorActive readmore_text" *ngIf="!isReadMore"
                                (click)="openPopUpDetail(data, i, templateAsset)">Read More</a>
                            </p>
                          </div>
                        </div>
                      </ngx-slick-carousel>
                    </div>
                  </div>
                </div>
                <div class="inTouchFormInnerWrap cmsWrapperMar">
                  <div class="whyClients mt-0">
                    <h1 class="topHdg">THINKING OF SELLING? LET'S TALK</h1>
                  </div>
                  <ng-container [ngTemplateOutlet]="contactFormHere"></ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.SELLER">
              <div class="who-we sellerCMS">
                <p class="des">
                  For over 25 years, we've been helping our clients meet and
                  exceed their asset liquidation goals. Whether you're
                  strategically downsizing, retiring, or simply looking to sell
                  your idle or unused assets, The Branford Group can help.
                </p>

                <p class="des">
                  We maximize returns for sellers. Plain and simple. Auctions
                  are designed to sell assets quickly, and take any negotiating
                  headaches out of the picture. Our strategy is based upon your
                  needs, and we’ll customize an event to ensure that your goals
                  are met.
                </p>

                <div class="inTouchFormInnerWrap cmsWrapperMar">
                  <div class="whyClients mt-0">
                    <h1 class="topHdg">THINKING OF SELLING? LET'S TALK</h1>
                  </div>
                  <ng-container [ngTemplateOutlet]="contactFormHere"></ng-container>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.VALUATIONS">
              <div class="logistic-wrap">
                <div class="valuationTopWrapper">
                  <div class="leftWrapper">
                    <h3>Equipment Valuations</h3>
                  </div>
                  <div class="rightWrapper">
                    <p class="">
                      Branford Valuations is a trusted provider of objective and
                      independent appraisal reports establishing the value of
                      industrial manufacturing machinery & equipment (M&E). Our
                      clients rely on our opinion because they know they can
                      make sound lending and business decisions to manage risk
                      effectively.
                    </p>

                    <div class="forBtns">
                      <button type="button" class="btn btn-white-border mr-3" [routerLink]="['/', routes.team]">
                        Meet Our Appraisers
                      </button>
                      <button type="button" role="button" (click)="scroll(target)" class="btn btn-colored">
                        Request Valuation
                      </button>
                    </div>
                  </div>
                </div>

                <div class="valuation2Wraps cmsMargNeg">
                  <div class="row">
                    <div class="col-md-5 mb-3 pr-md-1">
                      <div class="left-valuation">
                        <p>
                          Branford Valuations, LLC, prepares machinery &
                          equipment and inventory valuations for a range of
                          needs including:
                        </p>

                        <ul class="mb-0 pl-3">
                          <li>Financing & Leasing</li>
                          <li>Accounting</li>
                          <li>Estate Tax & Estate Planning</li>
                          <li>Litigation Support</li>
                          <li>Insurance</li>
                          <li>Mergers & Acquisitions</li>
                          <li>Business Decision Making</li>
                          <li>Asset Redeployment</li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-7 mb-3">
                      <div class="right-valuation">
                        <p>
                          Our valuation reports are among the most trusted and
                          respected in the industry. Branford’s staff includes
                          Certified Equipment Appraiser (CEA) and Accredited
                          Senior Appraiser (ASA) designated professionals who
                          are involved in all facets of the valuation
                          assignment.
                        </p>

                        <p>
                          Branford’s appraisals are developed based on our
                          lengthy professional experience and thorough knowledge
                          of valuation approaches. Our extensive proprietary
                          database of historical sales, first-hand understanding
                          of the market, and relationships with original
                          equipment manufacturers and dealers of industrial
                          assets are the tools we bring to each project.
                        </p>

                        <p class="m-0">
                          We provide our clients with accurate and reliable
                          appraisals they can trust. To read more about what
                          Branford’s clients are saying
                          <a href="/why-branford">Click here.</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="cmsMargNeg">
                  <img alt="appraisal" class="w-100" src="/assets/images/whatisappraisal.png" />
                </div>

                <div class="desktopAppraisalWrap">
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        A desktop appraisal is a method of analysis which
                        identifies and values the subject machinery & equipment
                        without the benefit of inspection. The appraiser
                        typically relies on information provided by the subject
                        company as the basis for analysis and reporting.
                      </p>
                      <p>
                        In order to provide you with the most accurate equipment
                        valuation, there are key aspects of the equipment
                        necessary for assessment.
                      </p>
                      <button type="button" class="btn btn-colored" role="button" (click)="openModal(template)">
                        View Desktop Appraisal Checklist
                      </button>
                    </div>
                  </div>
                </div>

                <div class="letUsOuterCMS cmsMargNeg">
                  <div class="row">
                    <div class="col-md-4">
                      <img alt="appraisal" class="img-fluid mb-2 mb-md-0" src="/assets/images/Need-An-Appraisal.png" />
                    </div>

                    <div class="col-md-8">
                      <p>
                        Depending on the intended use of the appraisal report,
                        Branford’s valuations can be conducted based on various
                        value premises. Commonly used value definitions are:
                      </p>

                      <ul class="pl-3">
                        <li>
                          Forced Liquidation Value (FLV) / Auction value (AV)
                        </li>
                        <li>Orderly Liquidation Value (OLV)</li>
                        <li>Fair Market Value (FMV) In-Place or Removed</li>
                        <li>Fair Value (FV)</li>
                        <li>Replacement Cost (RC) New or Used</li>
                      </ul>

                      <p class="mb-0">
                        Fees for valuations are quoted based on the scope of
                        each assignment. Factors include the quantity and type
                        of property, as well as how many Branford professionals
                        are required for the project. We pride ourselves on
                        offering competitive fees within the industry while
                        being dedicated to timely and accurate reports.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div #target class="inTouchFormInnerWrap cmsWrapperMar">
                <div class="whyClients mt-0">
                  <h1 class="topHdg">
                    Let The Branford Group Appraise Your Assets
                  </h1>
                </div>
                <ng-container [ngTemplateOutlet]="contactFormHere"></ng-container>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.WHOWEARE">
              <div class="who-we">
                <p class="des">
                  The Branford Group is a global industrial auction and
                  valuation business with proficiency across a wide array of
                  industries, and the unparalleled expertise to match buyers and
                  sellers around the world.
                </p>

                <p class="des">
                  For more than 25 years, our team of professionals has aligned
                  surplus industrial machinery, equipment, turn-key
                  manufacturing facilities, real estate, intellectual property,
                  and inventories with qualified buyers. Launched by
                  <a class="colorActive" [routerLink]="['/', routes.team]"><span class="colorActive">four industry
                      colleagues</span></a>
                  with diverse trade backgrounds and similar business
                  philosophies.
                </p>

                <div class="who-highlight">
                  <p>
                    The Branford Group Provides a “<span>30,000</span>-foot
                    perspective” while maintaining a one-on-one client
                    expertise.
                  </p>
                </div>

                <p class="des">
                  We can ensure that buyers and sellers have the information and
                  resources that are needed for a successful outcome because of
                  the leadership, vision, and extensive experience of our
                  accomplished management executives.
                </p>

                <p class="des">
                  Our three business divisions,
                  <a [routerLink]="['/', routes.currentAuction]" class="colorDarkUrl">Branford Auctions</a>
                  and
                  <a [routerLink]="['/', routes.valuations]" class="colorDarkUrl">
                    Branford Valuations
                  </a>
                  and
                  <a [href]="[routes.bgiSurplusLink]" target="_blank" class="colorDarkUrl">Branford Industrial Surplus
                  </a>
                  deliver the specialized services that we offer to our buyers
                  and sellers:
                </p>

                <div class="whoEachWrap pb-3">
                  <div class="imageText">
                    <img alt="Auction Liquidation" src="/assets/images/warehouse-header.jpg" />
                  </div>
                  <h2 class="imageTextName">Auctions + Liquidations</h2>
                  <p class="des">
                    All of our auctions are available to bidders world-wide,
                    through our timed online bidding platform or live
                    interactive webcasts. Bidders also have access to a variety
                    of on-location podium auctions, as well as negotiated
                    private treaty sales. We keep potential buyers informed of
                    upcoming auctions through targeted marketing campaigns,
                    personalized e-mail notifications and web site postings.
                  </p>
                  <p class="des">
                    Our international client base includes some of the biggest
                    names within the Global 2000, and our personalized project
                    management has become the gold standard and benchmark within
                    the auction industry.
                  </p>
                </div>

                <div class="whoAuctionWrap mb-3 mb-md-5">
                  <div class="row">
                    <div class="col-12">
                      <h3 class="rowName">Pre-Auction</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5 leftWho">
                      <img alt="Auction Liquidation" src="/assets/images/before-auction.jpg" />
                    </div>
                    <div class="col-md-7 righttWho">
                      <p class="des mb-3">
                        Whether you are strategically downsizing, or selling all
                        of your equipment and real estate, our custom-tailored
                        plans can help you meet your liquidity goals. We believe
                        that our job is not complete until the last tool and
                        workbench are removed. Our team will work with you and
                        your staff to leave the facility in a neat and tidy
                        manner within a designated timetable.
                      </p>
                      <h4 class="listHdg">PHASE I: Initial Assessment</h4>
                      <ul class="mb-3 mb-md-0 pl-3">
                        <li>Physical Plant Inspection</li>
                        <li>Assess Asset Market Value & Gross Proceeds</li>
                        <li>Determine Optimal Sales Strategy & Budgets</li>
                        <li>Contract Negotiation</li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <h3 class="rowName">Post-Auction</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5 leftWho">
                      <img alt="Auction Liquidation" src="/assets/images/after-auction.jpg" />
                    </div>
                    <div class="col-md-7 righttWho">
                      <h4 class="listHdg">
                        PHASE II: Project Plan Implementation
                      </h4>
                      <ul class="mb-4 pl-3">
                        <li>Site Preparation & Setup</li>
                        <li>Marketing (Website, Direct Mail/Email Campaign)</li>
                        <li>Bidder Preview & Inspection</li>
                        <li>Auction Day(s)</li>
                      </ul>
                      <h4 class="listHdg">
                        PHASE III: Project Completion & Settlement
                      </h4>
                      <ul class="mb-3 pl-3">
                        <li>Invoicing & Collection of Sales Proceeds</li>
                        <li>Settlement & Reporting</li>
                        <li>Final Client Walkthrough</li>
                      </ul>
                      <div class="whoEnquire">
                        <a [routerLink]="['/', routes.assetRecovery]">Our Asset Recovery Programs</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="whoEachWrap pb-5">
                  <div class="imageText">
                    <img alt="Auction Liquidation" src="/assets/images/warehouse-header2.jpg" />
                  </div>
                  <h2 class="imageTextName">Appraisals + Valuations</h2>
                  <p class="des mb-3">
                    Our accredited appraisers provide accurate machinery &
                    equipment and inventory valuations. First-hand knowledge and
                    a thorough understanding of the market are the tools we
                    bring to each valuation assignment. We deliver certified
                    appraisals that are relied upon by banks, finance companies,
                    accounting firms, tax and estate planning professionals,
                    turnaround firms, and corporations around the globe.
                  </p>
                  <a [routerLink]="['/', routes.valuations]" class="learnMore mb-3">Learn More</a>
                </div>

                <div class="whoEachWrap pb-5">
                  <div class="imageText">
                    <img alt="Auction Liquidation" src="/assets/images/warehouse-header3.jpg" />
                  </div>
                  <h2 class="imageTextName">Industrial Surplus</h2>

                  <div class="media pt-3 surplus-media">
                    <div class="img-surplus">
                      <img class="surplus-logo" alt="Auction Liquidation" src="/assets/images/surplus-logo.png" />
                    </div>
                    <div class="des-surplus">
                      <p class="des mb-3">
                        BGI Surplus is a premier industrial surplus warehouse.
                        We are a dedicated supplier to the manufacturing
                        industry, committed to providing buyers with quality,
                        new & used items. We offer a wide variety of machinery,
                        electronics and spare parts across a diverse array of
                        industries.
                      </p>
                      <a [href]="[routes.bgiSurplusLink]" target="_blank" class="learnMore">View Inventory</a>
                    </div>
                  </div>
                </div>

                <div class="whoEachWrap d-none">
                  <div class="imageText">
                    <img alt="Auction Liquidation" src="/assets/images/industryExpertise.png" />
                  </div>
                  <h2 class="imageTextName">Industry Expertise</h2>

                  <div class="row industryExpertiseList">
                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/automotive.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Automotive</h3>
                          <ul class="expertiseListing">
                            <li>Stamping</li>
                            <li>Assembly</li>
                            <li>Molding</li>
                            <li>Paint Lines</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/Biotech_Pharmaceutical.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Biotech/Pharmaceutical</h3>
                          <ul class="expertiseListing">
                            <li>Pharmaceutical Production</li>
                            <li>Test Laboratories</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/chemical.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Chemical</h3>
                          <ul class="expertiseListing">
                            <li>Paints & Adhesives</li>
                            <li>Compounding</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/construction.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Construction</h3>
                          <ul class="expertiseListing">
                            <li>Construction Equipment</li>
                            <li>Trucks & Trailers</li>
                            <li>Cranes</li>
                            <li>Concrete, Crushing & Asphalt Plants</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">
                            Electronic Test and Measurement
                          </h3>
                          <ul class="expertiseListing">
                            <li>Paints & Adhesives</li>
                            <li>Compounding</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/glass products.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Glass Products</h3>
                          <ul class="expertiseListing">
                            <li>Sheet Manufacturing</li>
                            <li>Bottling</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Food Industry</h3>
                          <ul class="expertiseListing">
                            <li>Processing</li>
                            <li>Packaging</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/information-technology.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Information Technology</h3>
                          <ul class="expertiseListing">
                            <li>Computers</li>
                            <li>Servers</li>
                            <li>Networking Equipment</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Metalworking</h3>
                          <ul class="expertiseListing">
                            <li>CNC & Manual Machining</li>
                            <li>Turning</li>
                            <li>Milling</li>
                            <li>Grinding</li>
                            <li>Automatic Machining</li>
                            <li>Fabricating</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Packaging</h3>
                          <ul class="expertiseListing">
                            <li>Bottling</li>
                            <li>Cartoning</li>
                            <li>Palletizing</li>
                            <li>Flexible</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Paper & Tissue</h3>
                          <ul class="expertiseListing">
                            <li>Converting</li>
                            <li>Corrugating</li>
                            <li>Folding</li>
                            <li>Processing</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/plastics.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Plastics</h3>
                          <ul class="expertiseListing">
                            <li>
                              Blow Molding (Industrial Containers, Bottles)
                            </li>
                            <li>PET Reheat/Stretch Blow Molding</li>
                            <li>Blown Film</li>
                            <li>Injection Molding</li>
                            <li>Rotational Molding</li>
                            <li>Thermoforming</li>
                            <li>
                              Extrusion (Sheet, Film, Pipe, Wire, Coating,
                            </li>
                            <li>Compounding & Pelletizing)</li>
                            <li>Recycling</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Primary Metals</h3>
                          <ul class="expertiseListing">
                            <li>Mills</li>
                            <li>Foundries</li>
                            <li>Service Centers</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/printed-circuit-board.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">
                            Printed Circuit Board (PCB)
                          </h3>
                          <ul class="expertiseListing">
                            <li>Single Layer</li>
                            <li>Multiple Layer</li>
                            <li>Back Plane</li>
                            <li>Manufacturing & Design</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Printing & Bindery</h3>
                          <ul class="expertiseListing">
                            <li>Sheet-fed</li>
                            <li>Web-fed</li>
                            <li>Pre-press</li>
                            <li>Binding</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/rubber.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Rubber</h3>
                          <ul class="expertiseListing">
                            <li>Mills</li>
                            <li>Extruders</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/semiconductor.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Semiconductor</h3>
                          <ul class="expertiseListing">
                            <li>Front End</li>
                            <li>Back End</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/surface-mount-technology.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">
                            Surface Mount Technology (SMT)
                          </h3>
                          <ul class="expertiseListing">
                            <li>Assembly</li>
                            <li>Through Hole</li>
                            <li>Surface Mount</li>
                            <li>Manufacturing & Design</li>
                            <li>Incircuit Testing</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Textile</h3>
                          <ul class="expertiseListing">
                            <li>Knitting</li>
                            <li>Cut & Sew</li>
                            <li>Die & Finishing</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Transportation</h3>
                          <ul class="expertiseListing">
                            <li>Buses (Intercity, Intracity, Coach)</li>
                            <li>Automobiles</li>
                            <li>Trucks & Trailers</li>
                            <li>Rail Equipment</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="eachExpertise">
                        <div class="leftWrap">
                          <img alt="expertise" src="/assets/images/electronic-measurement.jpg" />
                        </div>
                        <div class="rightWrap">
                          <h3 class="hdgExpertise">Woodworking</h3>
                          <ul class="expertiseListing">
                            <li>Saw Mills</li>
                            <li>Furniture</li>
                            <li>Cabinet Making</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="inTouchFormInnerWrap cmsWrapperMar">
                <div class="whyClients mt-0">
                  <h1 class="topHdg">THINKING OF SELLING? LET'S TALK</h1>
                </div>
                <ng-container [ngTemplateOutlet]="contactFormHere"></ng-container>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.WHYUS">
              <div class="why-choose d-none">
                <p class="desc pb-0 pb-md-2">
                  Across the board, our clients are our greatest advocates. We
                  have a wealth of testimonials with a consistent message:
                </p>

                <div class="cms-edge why-choose-list">
                  <div class="why-choose-list-inner">
                    <ul>
                      <li>
                        The Branford Group has a Deep knowledge of industry
                        trends and current values.
                      </li>
                      <li>
                        The Branford Group Communicates Every Detail of The
                        Project In Its Entirety.
                      </li>
                      <li>
                        The Branford Group Does Not Consider A Project Complete
                        Until The Client is 100% Satisfied.
                      </li>
                    </ul>
                  </div>
                </div>

                <p class="desc mb-2">
                  Understanding the wrold markets of industrial machinery and
                  equipment auctions and appraisals is our strength, and is
                  clearly reflected in the number of successful projects that
                  have been conducted by our team of professionals, Board of
                  Director seats, senior-level memberships, and elected
                  executive-level positions in industry organizations.
                  <br />
                  <br />
                  Manufacturers, bankruptcy consultants, attorneys, asset-based
                  lenders, and dealers look to us for guidance, advice, and
                  regulatory oversight. Among colleagues, clients, and
                  competitors alike, our knowledge and acumen is highly
                  respected.
                </p>
              </div>

              <div class="whyClients whyClientsMar d-none">
                <h1 class="topHdg">Words From Our Clients</h1>
                <div class="whyClientsInner custon-slick-dots">
                  <ngx-slick-carousel class="carousel" [config]="whyChooseSlider2">
                    <div ngxSlickItem class="slide">
                      <p>
                        From our initial meetings to the culmination of our
                        webcast auction, the group's professionalism and your
                        in-depth knowledge of the value of surplus equipment was
                        beyond expectations.
                      </p>
                      <h3>
                        George Marinakis, Senior Engineer/Polymer,
                        <br />Auction - Pitney Bowes
                      </h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        Throughout this project, I was impressed with the
                        services and professionalism of the staff, the attention
                        to detail, flexibility and of course, the fantastic
                        results of the sale.
                      </p>
                      <h3>Auction - Fisher Scientific</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        Since I have previous experience with other auction
                        service companies, I can truly say that The Branford
                        Group far exceeds its competition and is the leader in
                        the industry
                      </p>
                      <h3>Auction - C-COR</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        Their knowledge of the industry, combined with the
                        marketing and preparation of the assets prior to the day
                        of sale, resulted in a return that greatly exceeded our
                        expectations.
                      </p>
                      <h3>Auction - TTM Technologies</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        From start to finish from the beginning, your team
                        delivered on what you promised and we would definitely
                        choose to work with you in the future and recommend your
                        company.
                      </p>
                      <h3>Auction - Westlawn Graphic</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        My customer initially expressed concerns, however, after
                        reviewing your report the customer commented on a job
                        well done in a very professional manner.
                      </p>
                      <h3>Appraisal - People’s United Bank</h3>
                    </div>

                    <div ngxSlickItem class="slide">
                      <p>
                        Continue to go above and beyond exceeding expectation!
                      </p>
                      <h3>Appraisal - Chain Asset Management</h3>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>

              <div class="why-choose-map mt-30 d-none">
                <p class="desc2 mb-5">
                  At The Branford Group, every single client is partnered with a
                  member of our management team. This partnership ensures a
                  constant line of communication for every phase of the project,
                  regardless of size or scope. More than 30 years of referrals,
                  endorsements, and testimonials showcase the pledge to our
                  clients to exceed expectations. We’ve earned these valued
                  accoladesc by “rolling up our shirtsleeves” and fully
                  immersing ourselves into each and every project.
                </p>

                <div class="cms-edge why-map">
                  <div class="why-map-inner">
                    <img alt="why-map" class="why-map" src="/assets/images/why-map.jpg" />
                    <h1>A Network Like No Other</h1>
                    <h4>
                      With Over 25 years experience, The Branford Group is a
                      leader within the industrial auction and valuation
                      industries.
                    </h4>
                    <button class="btn btn-colored">
                      View Industry Experience
                    </button>
                  </div>
                </div>

                <p class="desc2 pb-2">
                  Delivering an unparalleled database of buyers from around the
                  world, while accurately assessing the value of assets is a
                  formula that we apply to every project. Our goal is to
                  maximize returns for our clients (or sellers), and by
                  integrating that formula into our exceptionally personalized
                  client experience, the end result is a successful business
                  transaction, but more importantly, a very happy client.
                  Whether you are looking to sell excess inventory, office
                  furniture, surplus equipment, or liquidate an entire business,
                  The Branford Group brings targeted buyers to your auction from
                  more than 45 countries spanning five continents.
                </p>

                <div class="cms-edge why-stats">
                  <div class="stats-inner">
                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-calender.svg" />
                      </div>
                      <h1>Over 100</h1>
                      <p>Auctions Conducted <br />Per Year</p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-billions.svg" />
                      </div>
                      <h1>Billions</h1>
                      <p>Of Assets Sold, <br />Appraise and Managed</p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-years.svg" />
                      </div>
                      <h1>25 Years</h1>
                      <p>Of Providing <br />Trusted Service</p>
                    </div>
                  </div>
                </div>

                <p class="desc2">
                  We maximize returns for sellers. Plain and simple. Auctions
                  are designed to sell assets quickly, and take any negotiating
                  headaches out of the picture. Our strategy is based upon your
                  needs, and we’ll customize an event to ensure that your goals
                  are met.
                </p>
              </div>

              <div class="historyTeam cmsMargNeg mb--50 d-none">
                <h2 class="historyTeamName">
                  Local Presence <br />
                  With Global Reach
                </h2>
                <h4 class="historyTeamDes">
                  Today, our headquarters are based in Connecticut with a team
                  comprised with diverse backgrounds and wealth of knowledge.
                </h4>
                <a type="button" class="btn btn-colored" [routerLink]="['/', routes.team]">
                  Meet The Team
                </a>
              </div>

              <div class="cmsHistory">
                <div class="cmsHistoryInner cmsHistoryInner2">
                  <h4 class="sbHistory text-center pb-3">
                    The Branford Group is a global industrial auction and
                    valuation business with proficiency across a wide array of
                    industries, and the unparalleled expertise to match buyers
                    and sellers around the world.
                  </h4>
                  <p class="historyDes pb-3 d-none">
                    For more than 25 years, our team of professionals have
                    aligned surplus industrial machinery, equipment, turn-key
                    manufacturing facilities, real estate, intellectural
                    proeprty, and inventories with qualified buyers. Launched by
                    four industry colleagues with diverse trade backgrounds and
                    similar business philosophies.
                  </p>
                </div>

                <div class="cms-edge why-map">
                  <div class="why-map-inner">
                    <img alt="why-map" class="why-map" src="/assets/images/why-map.jpg" />
                    <h1>A Network Like No Other</h1>
                    <h4>
                      With Over 25 years experience, The Branford Group is a
                      leader within the auction and valuation industries.
                    </h4>
                    <button [routerLink]="['/', routes.pastAuction]" class="btn btn-colored">
                      View Industry Experience
                    </button>
                  </div>
                </div>

                <div class="cmsHistoryInner cmsHistoryInner2">
                  <p class="historyDes pb-2">
                    Delivering an unparalleled database of buyers from around
                    the world, while accurately assessing the value of assets is
                    a formula that we apply to every project. Our goal is to
                    maximize returns for our clients (or sellers). By
                    integrating that formula into our exceptionally personalized
                    client experience, the end result is a successful business
                    transaction - but more importantly, a very happy client.
                    Whether you are looking to liquidate an entire business,
                    surplus equipment, or simply sell excess inventory, The
                    Branford Group brings targeted buyers to your sale from more
                    than 45 countries spanning five continents.
                  </p>
                </div>
                <div class="cms-edge why-stats mb-5">
                  <div class="stats-inner">
                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-calender.svg" />
                      </div>
                      <h1>Over 100</h1>
                      <p>Auctions Conducted <br />Per Year</p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-billions.svg" />
                      </div>
                      <h1>Billions</h1>
                      <p>Of Assets Sold, <br />Appraised and Managed</p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/stats-years.svg" />
                      </div>
                      <h1>25 Years</h1>
                      <p>Of Providing <br />Trusted Service</p>
                    </div>
                  </div>
                </div>

                <div class="cmsHistoryInner cmsHistoryInner2">
                  <p class="historyDes pb-2">
                    At The Branford Group, every client is partnered with a
                    member of our management team. This partnership ensures a
                    constant line of communication for every phase of the
                    project, regardless of size or scope. More than 25 years of
                    referrals, endorsements, and testimonials showcase the
                    pledge to our clients to exceed expectations. We’ve earned
                    these valued accolades by “rolling up our shirtsleeves” and
                    fully immersing ourselves into each and every project.
                  </p>
                </div>

                <div class="historyTeam cmsMargNeg historyTeamWithImage">
                  <h2 class="historyTeamName">
                    Local Presence <br />
                    With Global Reach
                  </h2>
                  <h4 class="historyTeamDes">
                    Our headquarters are based in Connecticut, with satellite
                    offices around the country and a team comprised of diverse
                    backgrounds and wealth of knowledge.
                  </h4>
                  <a type="button" class="btn btn-colored" [routerLink]="['/', routes.team]">
                    Meet The Team
                  </a>
                </div>

                <div class="cmsHistoryInner cmsHistoryInner2">
                  <p class="historyDes pb-2">
                    Across the board, our clients are our greatest advocates.
                    Manufacturers, bankruptcy consultants, attorneys,
                    asset-based lenders, and dealers look to us for guidance,
                    advice, and oversight. Among colleagues, clients, and
                    competitors alike, our knowledge and acumen are highly
                    respected.
                  </p>
                </div>

                <div class="whyClients whyClientsMar">
                  <h1 class="topHdg">Words From Our Clients</h1>
                  <div class="whyClientsInner custon-slick-dots">
                    <ngx-slick-carousel class="carousel" [config]="whyChooseSlider2">
                      <div ngxSlickItem class="slide">
                        <p>
                          From our initial meetings to the culmination of our
                          webcast auction, the group's professionalism and your
                          in-depth knowledge of the value of surplus equipment
                          was beyond expectations.
                        </p>
                        <h3>
                          George Marinakis, Senior Engineer/Polymer,
                          <br />Auction - Pitney Bowes
                        </h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          Throughout this project, I was impressed with the
                          services and professionalism of the staff, the
                          attention to detail, flexibility and of course, the
                          fantastic results of the sale.
                        </p>
                        <h3>Auction - Fisher Scientific</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          Since I have previous experience with other auction
                          service companies, I can truly say that The Branford
                          Group far exceeds its competition and is the leader in
                          the industry
                        </p>
                        <h3>Auction - C-COR</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          Their knowledge of the industry, combined with the
                          marketing and preparation of the assets prior to the
                          day of sale, resulted in a return that greatly
                          exceeded our expectations.
                        </p>
                        <h3>Auction - TTM Technologies</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          From start to finish from the beginning, your team
                          delivered on what you promised and we would definitely
                          choose to work with you in the future and recommend
                          your company.
                        </p>
                        <h3>Auction - Westlawn Graphic</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          My customer initially expressed concerns, however,
                          after reviewing your report the customer commented on
                          a job well done in a very professional manner.
                        </p>
                        <h3>Appraisal - People’s United Bank</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          Continue to go above and beyond exceeding expectation!
                        </p>
                        <h3>Appraisal - Chain Asset Management</h3>
                      </div>

                      <div ngxSlickItem class="slide">
                        <p>
                          In 2017 alone, The Branford Group conducted over $10
                          million dollar in revenue for GE. To date, The
                          Branford Group has sold the highest grossing amount at
                          auction for one item of equipment in GE’s long
                          history.
                        </p>
                        <h3>John Mader, GE</h3>
                      </div>
                    </ngx-slick-carousel>
                  </div>
                </div>

                <div class="why-choose-map">
                  <div class="histroyInnerBannerWrap cmsWrapperMar">
                    <div class="histroyInnerBannerWrap2">
                      <img src="/assets/images/warehouse-inner-header.jpg" />
                      <h1>EXPERTS IN LIQUIDITY</h1>
                    </div>
                  </div>

                  <div class="histroyInnerBannerData cmsHistoryInner cmsHistoryInner2 mb-4 pb-md-2">
                    <div class="cmsHistoryInner cmsHistoryInner2 pt-4 mt-3">
                      <p class="historyDes mb-0">
                        Our project management team and certified appraisers
                        have experience around the world - having conducted
                        thousands of auctions and appraisals across a wide
                        variety of industries.
                      </p>
                    </div>
                    <div class="cmsHistoryInner cmsHistoryInner2 pt-4 mt-3">
                      <p class="historyDes mb-0">
                        Understanding the world markets of industrial machinery
                        and equipment auctions and appraisals is our strength,
                        and is clearly reflected in the number of Board of
                        Director seats, senior-level memberships, and successful
                        projects that have been conducted by our team of
                        professionals.
                      </p>
                    </div>
                    <div class="text-center pt-5">
                      <img class="w-100 mb-3" src="/assets/images/chooseLogos.jpg" />
                      <a [routerLink]="['/', routes.pastAuction]" class="btn btn-colored pl-md-4 pr-md-4"
                        role="button">View All Past Auctions</a>
                    </div>
                  </div>
                </div>
                <section class="history-section pt-4">
                  <div class="histroyInnerBannerWrap cmsWrapperMar">
                    <div class="histroyInnerBannerWrap2">
                      <img src="/assets/images/25_year_in_business.jpg" />
                      <h1>25 years in Business</h1>
                    </div>
                  </div>
                  <div class="cmsHistorySlider pt-4 mt-3">

                    <div class="row align-items-center">
                      <div class="col-12 col-md-6">
                        <p class="historyDes ourhistory-text mb-0">
                          Since 1997, our team of professionals have aligned
                          surplus industrial machinery, equipment, turn-key
                          manufacturing facilities and real estate, with
                          qualified buyers. The Branford Group was formed by
                          <a href="/team"><span class="theme-red-text">four industry colleagues</span></a>
                          with diverse trade backgrounds and similar business
                          philosophies. From our inception to today, our goals
                          remain the same:
                        </p>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="histortTeamsliderInner">
                          <ngx-slick-carousel class="carousel" [config]="cmsHistorySliderConfig">
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide1.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide2.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide3.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">

                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide4.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide5.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide6.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide7.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide8.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide9.jpg" />
                              </div>
                            </div>

                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide10.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide11.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide12.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide13.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide14.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide15.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide16.jpg" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide17.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide18.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide19.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide20.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide21.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide22.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide23.png" />
                              </div>
                            </div>
                            <div ngxSlickItem class="slide">
                              <div class="teamImage">
                                <img alt="team" class="teamThumbnail" src="/assets/images/historySlide24.png" />
                              </div>
                            </div>
                          </ngx-slick-carousel>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div class="cms-edge why-stats why-stats-1">
                  <div class="stats-inner">
                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/icon_1.svg" />
                      </div>
                      <p>
                        We do not consider a project complete until the client
                        is 100% satisfied.
                      </p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/icon_2.svg" />
                      </div>
                      <p>
                        Maintain a consistent and open line of communication
                        with the client.
                      </p>
                    </div>

                    <div class="stats-parts">
                      <div class="stat-icon">
                        <img alt="icon" class="stats-icon" src="/assets/images/icon_3.svg" />
                      </div>
                      <p>
                        Practice continuing education to advise our clients
                        current market values.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="staticPage.PAYMENTS">
              <div class="sellerRecovery removal-wrap removal-wrap-new payment_methods_lists">
                <p class="desText pb-2">
                  Payment in full is <b>due within 48 hours</b> after the final
                  sale day. Unless specified otherwise, all acceptable forms of
                  payment are:
                </p>
                <ul class="desText">
                  <li class="clickLink">Cash Onsite</li>
                  <li class="clickLink">Wire Transfer/ACH</li>
                  <li class="clickLink">Certified/Company Checks</li>
                  <li class="clickLink">Direct deposit at a Bank of America</li>
                  <li class="clickLink">
                    Credit card: Visa, Mastercard, American Express
                  </li>
                </ul>

                <p class="desText pb-4">
                  We do not accept personal checks. All payments must be made in
                  US funds (unless otherwise specified on the Auction Details
                  page or your invoice).
                </p>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/WireTransferACH.png" />
                    <h2 class="imageTextName">WIRE TRANSFER & ACH</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText">
                    Complete Wire Transfer details will be available on your
                    invoice. When sending payment by wire transfer,
                    <b>please include your buyer name, buyer number and auction
                      name.</b>
                  </p>
                  <p class="desText">
                    There are 2 different ABA’s for Wires Vs ACH. Please follow
                    the correct instructions.
                  </p>

                  <p class="desText pb-4">
                    Please call
                    <a class="clickLink" href="tel:+1-203-488-7020">1-203-488-7020</a>
                    for our current bank details and wire instructions.
                  </p>
                </div>

                <div class="whoEachWrap pb-3">
                  <div class="imageTextWrap cmsMargNeg mb-55">
                    <img alt="Auction Liquidation" src="/assets/images/payment2.jpg" />
                    <h2 class="imageTextName">REMOVAL & CHECKOUT</h2>
                    <div class="clearfix"></div>
                  </div>
                  <p class="desText">
                    All items must be removed no later than the final removal
                    date specified for each auction. Items can be removed during
                    normal business hours Monday thru Friday, 8am to 4pm only –
                    there is no removal on weekends (unless otherwise specified
                    on the Auction Details page or your invoice).
                  </p>
                  <p class="desText pb-4">
                    All riggers, purchasers, or purchaser’s agent who will be
                    bringing in any equipment or machinery to be used in the
                    process of removing any assets from the facility, will be
                    required to have a minimum of two million dollars of general
                    liability insurance and provide The Branford Group with
                    <a [href]="removalDocuments[1].name" target="_blank" class="clickLink">Certificate of Insurance.</a>
                  </p>
                  <p class="desText">
                    Once you have made your payment in full, you will be emailed
                    a copy of your receipt/paid in full invoice. You or your
                    agent must present this to The Branford Group representative
                    on-site who will then start the checkout process and allow
                    you to remove your items. If you or your agent cannot remove
                    all items on the same day, you or they will be required to
                    show the original check out copy of your invoice to retrieve
                    your remaining items
                  </p>
                </div>
                <!-- sales cms -->
                <div class="sales_tax_cns_wrapper">
                  <div class="whoEachWrap pb-3">
                    <div class="imageTextWrap cmsMargNeg mb-55">
                      <img alt="Auction Liquidation" src="/assets/images/SalesTax.png" />
                      <h2 class="imageTextName">Sales Tax</h2>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div [innerHtml]="content"></div>
                </div>
                <!-- sales cms -->
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <div [innerHtml]="content"></div>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #contactFormHere>
  <div class="inTouchForm pt-3">
    <div class="inTouchFormInner">
      <h1 class="hdgMain">Get In Touch</h1>
      <p class="formDes">
        Contact us today at 203-488-7020 to speak directly with one of our
        {{
        currentStaticPage == staticPage.VALUATIONS
        ? "appraisal professional"
        : "auction professionals"
        }}
        or complete the required fields, and we will contact you as soon as
        possible.
      </p>
      <form [formGroup]="contactForm">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">First Name*</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="firstName" [maxlength]="fieldMaxLength20"
                  placeholder="Enter your first name" />
              </mat-form-field>
              <control-messages [control]="contactForm.controls.firstName"></control-messages>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">Last Name*</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="lastName" [maxlength]="fieldMaxLength20"
                  placeholder="Enter your last name" />
              </mat-form-field>
              <control-messages [control]="contactForm.controls.lastName"></control-messages>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">Email*</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="email" [maxlength]="fieldMaxLength50"
                  placeholder="Enter email" />
              </mat-form-field>
              <control-messages [control]="contactForm.controls.email"></control-messages>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">Phone Number*</label>
              <mat-form-field appearance="outline">
                <input matInput type="tel" formControlName="mobileNumber" [maxlength]="fieldMaxLength30"
                  placeholder="Enter phone number" />
              </mat-form-field>
              <control-messages [control]="contactForm.controls.mobileNumber"></control-messages>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">Company*</label>
              <mat-form-field appearance="outline">
                <input matInput type="text" formControlName="companyName" [maxlength]="fieldMaxLength50"
                  placeholder="Enter company name" />
              </mat-form-field>
              <control-messages [control]="contactForm.controls.companyName"></control-messages>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-4 no-float-fields">
              <label class="form-label">Message*</label>
              <mat-form-field appearance="outline">
                <textarea formControlName="message" [maxlength]="fieldMaxLength500" rows="8" matInput
                  placeholder="Write here"></textarea>
              </mat-form-field>
              <control-messages [control]="contactForm.controls.message"></control-messages>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-4">
              <re-captcha required [formControl]="captcha" [siteKey]="captchaKey"></re-captcha>
            </div>
          </div>

          <div class="col-lg-12">
            <button type="submit" class="btn btn-colored" [disabled]="captcha.invalid || contactForm.invalid" role="button"
              (click)="submitForm()">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #template>
  <div class="viewApprisalModalBody">
    <span aria-label="Close" role="button" (click)="modalRef.hide()" class="cursor-pointer closeIcon">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <g fill="none" fill-rule="evenodd">
          <g>
            <g>
              <g>
                <g
                  transform="translate(-1029.000000, -333.000000) translate(364.000000, 313.000000) translate(402.000000, 0.000000) translate(263.000000, 20.000000)">
                  <circle cx="14" cy="14" r="14" fill="#F3F3F3" fill-rule="nonzero" />
                  <path fill="#3B3B3B" stroke="#F3F3F3" stroke-width=".5"
                    d="M18.723 9.277c-.37-.37-.968-.37-1.338 0L14 12.662l-3.385-3.385c-.37-.37-.968-.37-1.337 0-.37.37-.37.969 0 1.338L12.662 14l-3.385 3.385c-.37.37-.37.968 0 1.338.185.184.427.277.669.277.242 0 .484-.093.669-.277L14 15.337l3.385 3.386c.185.185.427.277.669.277.242 0 .484-.092.669-.277.37-.37.37-.969 0-1.338L15.338 14l3.385-3.385c.37-.37.37-.968 0-1.338z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
    <div class="leftWrap">
      <img alt="image" class="appraisal" src="/assets/images/appraisal.jpg" />
      <div class="innerData">
        <h1>Desktop Appraisal Checklist</h1>
      </div>
    </div>
    <div class="rightWrap">
      <ul>
        <li>Make</li>
        <li>Model</li>
        <li>Age</li>
        <li>Description</li>
        <li>Serial Number</li>
        <li>Hours</li>
        <li>Capacity</li>
        <li>Photographs or virtual tour of key equipment</li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #templateAsset>
  <div class="member-wrap financial-str-modal">
    <div class="des-wrap">
      <div class="close-icon-wrap">
        <button type="button " class="close circle-icon" aria-label="Close " role="button" (click)="modalRef.hide()">
          <img src="../assets/images/cross.svg " />
        </button>
      </div>

      <div class="name-wrap">
        <h1 class="name">
          {{ viewDetails.title }}
        </h1>
      </div>
      <div class="dtl-wrap">
        <p [innerHTML]="viewDetails.description"></p>
      </div>
    </div>
  </div>
</ng-template>
